module.exports = __webpack_public_path__ + "img/fix_logo.a5e811b1.svg";